var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__body pt-4 ml-2 mr-2"},[_c('div',{staticClass:"form"},[_c('Calendar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }